import { Col, Row, Tabs } from "antd";
import languageData from "../../../domain/core/AppLanguageSwitcher/data";
import * as React from "react";

type childrenList = {
    code?: string;
    languageId?: string;
    langComponent: React.ReactNode;
};

type tabItem = {
    key: string;
    label: string;
    children: React.ReactNode;
};

interface ILanguagesTabProps {
    languagesList: childrenList[];
    tabItem?: tabItem;
    // Optional: control the open tab (e.g. to show a tab that holds a validation error).
    activeKey?: string;
    onChange?: (key: string) => void;
    // Optional: mount every tab up front so the fields of unopened tabs are validated too.
    forceRender?: boolean;
}

const LanguagesTab = (props: ILanguagesTabProps) => {
    const { tabItem, languagesList, activeKey, onChange, forceRender } = props;
    return (
        <Tabs
            activeKey={activeKey}
            onChange={onChange}
            items={
                tabItem ? [
                    { ...tabItem, forceRender },
                    ...languageData.sort((a, b) => a.name.localeCompare(b.name)).map((language) => {
                        return {
                            key: language.code,
                            forceRender,
                            label:
                                <>
                                    <Row gutter={7}>
                                        <Col>
                                            <i className={`flag flag-24 flag-${language.icon}`} />
                                        </Col>
                                        <Col>
                                            <h4 className="title-tab">{language.name}</h4>
                                        </Col>
                                    </Row>
                                </>,
                            children: <>
                                {languagesList && languagesList?.length > 0 ?
                                    languagesList?.find((item) =>
                                        (item.languageId && item.languageId === language.code) ||
                                        item.code === language.code
                                    )?.langComponent ?? <></>
                                    : <></>
                                }
                            </>
                        }
                    })]
                    :
                    languageData.sort((a, b) => a.name.localeCompare(b.name)).map((language) => {
                        return {
                            key: language.code,
                            forceRender,
                            label:
                                <>
                                    <Row gutter={7}>
                                        <Col>
                                            <i className={`flag flag-24 flag-${language.icon}`} />
                                        </Col>
                                        <Col>
                                            <h4 className="title-tab">{language.name}</h4>
                                        </Col>
                                    </Row>
                                </>,
                            children: <>
                                {languagesList && languagesList?.length > 0 ?
                                    languagesList?.find((item) =>
                                        (item.languageId && item.languageId === language.code) ||
                                        item.code === language.code
                                    )?.langComponent ?? <></>
                                    : <></>
                                }
                            </>
                        }
                    })
            }
        />
    );
};

export default LanguagesTab;